import { useState } from "react"
import Icon from "./Icon"
import Browser from "./Browser"
import Desk from "./Desk"
const Lerp = ({setAnimations,animations}) => {

    const [open,setOpen] = useState(false)
    const [cur,setCur] = useState('medium')
    const availableLerps = [{
        val:1,
        des:'none'
    },
    {
        val:.25,
        des:'shortest'
    },
    {
        val:.15,
        des:'short'
    },
    {
        val:.1,
        des:'medium'
    },
    {
        val:.025,
        des:'long'
    },
    
    
    {
        val:.01,
        des:'longest'
    }]

    const caret = <svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12"><g transform="translate(0, 0)"><path d="M11.5,2H.5a.5.5,0,0,0-.412.783l5.5,8a.5.5,0,0,0,.824,0l5.5-8A.5.5,0,0,0,11.5,2Z"></path></g></svg>

    const action = v => {
        const newData = {...animations}
        newData.data['.lerpCursor'].parallax.lerp = v
        setAnimations(newData)
    }

    const dots = () => {
        const ret = []
        for (let m = 0; m < 20; m++){
            ret.push(<div className='w-2 h-2 bg-slate-200 rounded-full' key={m}></div>)
        }
        return ret;
    }

    const dropper = () => {

        const ret = availableLerps.map(e=><div className='capitalize hover:text-indigo-400 rounded-xl h-16 px-5 flex items-center' onClick={()=>{
            action(e.val)
            setCur(e.des)
        }} key={e.des}>{e.des}</div>)

        const contents = open ? <>
            <div onClick={()=>setOpen(false)} className='fixed top-0 left-0 w-screen h-screen z-40 '></div>
            <div className='z-50 -mb-px absolute bottom-0 left-0 w-full bg-white rounded-3xl ring-2 ring-slate-100'>{ret}</div>
        </> : <></>

        return <div onClick={()=>setOpen(!open)} className='flex z-[99] w-[300px] rounded-3xl justify-between bg-white items-center transition-all text-base h-16 px-5 border-2 border-slate-100 hover:border-slate-200 cursor-pointer relative capitalize'>{cur}{caret}
    
        {contents}
        <div className='absolute bottom-full left-0 py-2 w-full text-center text-slate-300 text-xs'>Interpolation Length</div>
        </div>

    }

    return <section className='lerpWrap relative z-40 overflow-hidden px-5 lg:px-0'>
        <div className='container py-20 lg:pt-40 relative flex items-center mx-auto flex-col justify-center zoomClaim'>
        <div className=" relative text-center flex-col mx-auto flex max-w-prose items-center z-50 ">
                <Icon name='lerp' outer='bg-indigo-400 bg-opacity-10' inner='fill-indigo-400' />
                <h2>LERP: build natural animations with <span>Linear Interpolations</span></h2>
                <p className='sub'>Use Linear Interpolation to smoothen and make more organic element's scroll behaviours. The higher the value the longest the interpolation will be.</p>
              
            </div>
            
            <div className='px-8 py-4 bg-white shadow-2xl shadow-slate-200 rounded-[50px]'>
        
                <div className=' w-[800px] relative h-10 flex items-center justify-between'>
                    <div className='lerpCursorStatic absolute top-0 left-0 w-10 h-10 bg-indigo-500 bg-opacity-30 -mx-4 rounded-full z-10'></div>
                    <div className='lerpCursor absolute top-0 left-0 w-8 h-8 bg-indigo-500 -mx-3 mt-1 rounded-full z-20'></div>
                    {dots()}
                </div>
            </div>
        
            <div className='mt-20 flex gap-10 w-full max-w-prose flex-col lg:flex-row'>
                
                <div className='flex-1 flex justify-center mb-10'>
                    {dropper()}
                </div>
                <div className='flex-1 text-center lg:text-left'>
                    <p className='text-slate-400 text-sm'>
                    Select a different Interpolation length and scroll the page to experience the difference.<br /> <br />
                    The background (lighter) dot follows the browser natural scrolling motion while the foreground (darker) one has a Linear Interpolation (LERP) effect applied. Interpolated animations feel smoother.</p>
                </div>
            </div>
       
        </div>
        <div className='container mx-auto'>
            <Desk from='from-indigo-400' via='via-purple-200' to='to-indigo-50'>
                <Browser>
                    <video autoPlay muted loop width="100%">
                    <source src="https://csshero.org/wp-content/themes/dingo22/assets/vids/animator_video_drone.mp4" type="video/mp4" />
                    </video>

                </Browser>
            </Desk>
        </div>
    </section>
}

export default Lerp